module.exports = __webpack_public_path__ + "media/assets/icons/angle-double-right-b72dea3568113034578747e2d828c286.svg";